import { memo, useState } from 'react'
import { Button, Flex, Text } from '@chakra-ui/react'

import { useFilterGroupForDates } from './contexts/Provider'
import { CalendarFilter } from 'components'

const FilterGroupByDateContent = () => {
  const [calendarDates, setCalendarDates] = useState<any>({})

  const { onSubmitFilter, filterDate, setFilterDate } = useFilterGroupForDates()

  return (
    <>
      {filterDate?.label && (
        <Flex direction="column" mb={4} gap={1}>
          <Text fontSize="md">Está filtrando por: </Text>
          <Text textAlign="left" color="primary" fontSize="md">
            {filterDate?.label}
          </Text>
        </Flex>
      )}

      <Flex direction="column" gap={4}>
        <CalendarFilter
          modalTitle="Selecione o filtro de data"
          defaultDates={calendarDates}
          onSubmit={(datas) => {
            setCalendarDates(datas)
            setFilterDate({ ...filterDate, label: datas.dateFeedback })
            onSubmitFilter(datas)
          }}
          trigger={
            <Button minWidth="100%" id="open-data-filter-button" variant="outline" colorScheme="primary">
              Selecione o filtro de data
            </Button>
          }
        />
      </Flex>
    </>
  )
}

export default memo(FilterGroupByDateContent)
